import Config from "../../config";

export const google = Config.google_properties;
// todo update redirect_uri while sharing coa build
export const { googleProperties } = Config;
